import {
    GetUserRequest,
    GetUserResponse,
} from "@amzn/ermine-ssr-sdk/clients/ermineserversiderenderingservice";
import { AWSError } from "aws-sdk";
import log from "../../logging";
import { useQuery } from "@tanstack/react-query";
import { getErmineSsrClient } from "../../utils/ermineSsrClientUtil";
import {
    getFormattedAwsErrorMessage,
    isAWSError,
} from "../../utils/errorUtils";

export const useAuthCheck = () => {
    const result = useQuery<GetUserResponse, AWSError>({
        queryKey: ["getUser"],
        retry: false,
        queryFn: async () => {
            try {
                return await getErmineSsrClient()
                    .makeUnauthenticatedRequest("getUser", {} as GetUserRequest)
                    .promise();
            } catch (err) {
                // If the user hasn't signed in yet or has already signed out, the API will throw an exception.
                log.info(
                    isAWSError(err)
                        ? getFormattedAwsErrorMessage(err, "SSOAuthChecker")
                        : "Failed to get user data"
                );
                throw err;
            }
        },
    });

    return {
        userInfo: result.data,
        authCheckResponseId: `get_user_${result.dataUpdatedAt}`,
        isCheckingAuth: result.isLoading,
        isAuthCheckError: result.isError,
        checkAuth: result.refetch,
    };
};
